import template from './profileGroups.html';

export default {
  name: 'proGroupsComponent',
  template,
  controllerAs: 'ProfGrpCtrl',
  bindings: {
    groups: '<'
  }
};
